export default __webpack_public_path__ + "static/media/icon_peruskriteerit_valmis.7e125ed0.svg";